import { render, staticRenderFns } from "./AWidget.vue?vue&type=template&id=6f567616&scoped=true&"
import script from "./AWidget.vue?vue&type=script&lang=ts&"
export * from "./AWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AWidget.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AWidget.vue?vue&type=style&index=1&id=6f567616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f567616",
  null
  
)

export default component.exports